import React, { ReactElement, useEffect, useState } from 'react';
import { useDataCollection, useWizardNavigation } from '../../../../hooks';
import { Form } from 'formik';
import StepHeader from '../../../components/Layout/StepHeader';
import { clearFormDataLocalStorage } from '../../../components/Persistence/formLocalStorage';
import { WizardName } from '../../../../types';
import logger from '../../../../tools/logger';
import callWizardApi from '../../../../api/wizard/callWizardApi';

const StepFinal = (): ReactElement<'div'> | null => {
    const { values } = useDataCollection();
    const { callFinal, setCallFinal } = useWizardNavigation();
    const [sending, setSending] = useState(false);
    const [calculationDone, setCalculationDone] = useState(false);
    const [calculationError, setCalculationError] = useState('');
    const wizardApiUrl = '/api/v1/otz';

    useEffect(() => {
        if (callFinal) {
            setSending(true);
            setCalculationError('');
            callWizardApi(wizardApiUrl, values)
                .then((data) => {
                    logger('[Wizard API] call done!', data);

                    if (data.status === 'NOK') {
                        setCalculationError('Chyba zpracování dat');
                        logger('[Wizard API] call error', data.error);
                        setSending(false);
                        return;
                    }

                    if (data.redirectUrl) {
                        setCalculationDone(true);
                        clearFormDataLocalStorage(WizardName.otz); // TODO share value from HOC
                        window.location.href = data.redirectUrl;
                    }
                })
                .catch((error) => {
                    logger('[Wizard API] call error', error);
                    setSending(false);
                    setCalculationError('Chyba odeslání dat');
                    setCallFinal(false);
                });
        }
    }, [callFinal]);

    return (
        <Form>
            <div className="otz-main otz-main--final">
                <StepHeader
                    title="Vypadá to, že máme vše potřebné"
                    subtitle="Všechny otázky zodpovězeny 🙂"
                    img={{ url: '/img/data/otz-final.svg', alt: 'final-img' }}
                />
                {sending && (
                    <div className="ta-c otz-class--success">
                        <strong>Odesílám data...</strong>
                    </div>
                )}
                {calculationError && (
                    <div className="ta-c otz-class--error">
                        <strong>Chyba zpracování!</strong>
                    </div>
                )}
            </div>
        </Form>
    );
};

export default StepFinal;
